import { Instagram } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Home", href: "#top" },
  { label: "Cakes", href: "#custom-cakes" },
  { label: "Flavors", href: "#flavors" },
  { label: "Gallery", href: "#work" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Request a Cake", href: "#inquiry" },
];

const Footer = () => (
  <footer className="border-t border-[#E8D8D3] bg-[#FDFBF7] pb-28 pt-16 lg:pb-16" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-sm">
          <img src="/logo.png" alt="Bella Bells Cakes" className="h-20 w-auto mix-blend-multiply" data-testid="footer-logo" />
          <p className="mt-4 text-sm leading-relaxed text-[#5C4B47]">
            Custom cakes and handcrafted desserts made for life&rsquo;s sweetest celebrations.
          </p>
          <p className="mt-4 font-accent text-[11px] font-bold uppercase tracking-[0.24em] text-[#C48B71]" data-testid="footer-licensed">
            Licensed Bakery | San Diego, CA
          </p>
        </div>

        <nav className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-3" data-testid="footer-links">
          {LINKS.map((l) => (
            <button
              key={l.label}
              onClick={() => scrollToId(l.href)}
              className="text-left text-sm text-[#5C4B47] transition-colors duration-300 hover:text-[#C48B71]"
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </button>
          ))}
          <a
            href="https://www.instagram.com/bellabellscakes"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm text-[#5C4B47] transition-colors duration-300 hover:text-[#C48B71]"
            data-testid="footer-instagram-link"
          >
            <Instagram size={14} strokeWidth={1.5} /> @bellabellscakes
          </a>
        </nav>
      </div>

      <div className="mt-14 flex flex-col gap-2 border-t border-[#E8D8D3] pt-8 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-[#8A7975]">&copy; {new Date().getFullYear()} Bella Bells Cakes. All rights reserved.</p>
        <p className="font-display text-sm italic text-[#8A7975]">Baked with love, est. 2021</p>
      </div>
    </div>
  </footer>
);

export default Footer;
